module.exports = __webpack_public_path__ + "img/marion.db09ed93.jpg";